<template>
  <div class="device-redirect">
    <div class="loading-wrapper">
      <div class="loading-spinner"></div>
      <div class="loading-text">页面加载中...</div>
    </div>
  </div>
</template>

<script>
import deviceDetection from '@/mixins/deviceDetection'
export default {
  name: 'DeviceRedirect',
  mixins: [deviceDetection],
  created () {

  }
}
</script>

<style scoped>
.device-redirect {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8fafc;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-text {
  color: #64748b;
  font-size: 14px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
